import { createSlice } from '@reduxjs/toolkit';
import { showToast } from '../../utils/toast';

const initialState: any = {
    user: null,
    theme: 'light',
    isLoading: false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        themeReq: (state, action) => {
            state.theme = action.payload;
        },
        signReq: (state, action) => {
            state.user = null;
            state.isLoading = true;
        },
        signInRes: (state, action) => {
            state.user = action.payload;
            state.isLoading = false;
        },
        signInErr: (state, action) => {
            state.isLoading = false;
            showToast(action.payload.message, 'error')
        },
        verifyReq: (state) => {
            state.user = null;
            state.isLoading = true;
        },
        verifyRes: (state, action) => {
            state.user = action.payload;
            state.isLoading = false;
        },
        verifyErr: (state, action) => {
            state.user = undefined;
            state.isLoading = false;
            showToast(action.payload.message, 'error')
        },
        updateDPReq: (state, action) => {
            state.isLoading = true;
        },
        updateDPRes: (state, action) => {
            if (action?.payload?.error)
                return showToast(action.payload.message, 'error')
            state.user.profile.img = action.payload
            state.isLoading = false;
        },
        updateDPErr: (state, action) => {
            state.isLoading = false;
            showToast(action.payload.message, 'error')
        }
    },
});

export const { signReq, signInRes, signInErr, verifyReq, verifyRes, verifyErr, themeReq } = authSlice.actions;
export const authReducer = authSlice.reducer;
export const authActions = authSlice.actions;
export default authSlice;
